import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { dispatch } from '../store';
import { CONSTS } from './const';
// ----------------------------------------------------------------------

type CdnState = {
  cdnError: boolean;
  isCdnLoading: boolean;
};

const initialState: CdnState = {
  cdnError: false,
  isCdnLoading: false
};

const slice = createSlice({
  name: 'cdn',
  initialState,
  reducers: {

    startCdnLoading(state) {
      state.isCdnLoading = true;
    },

    stopCdnLoading(state) {
      state.isCdnLoading = false;
    },

    hasErrorCdn(state, action) {
      state.isCdnLoading = false;
      state.cdnError = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export async function getImageFromPath(path: string) {
  dispatch(slice.actions.startCdnLoading());
  try {
    const response = await axios.get(`${process.env.REACT_APP_MAIN_CDN_URL}${CONSTS.CDN_DOWNLOAD_FILE}?path=${path}`, {
      headers: {
        'x-access-token': localStorage.getItem('accessToken') || null
      },
      responseType: 'blob'
    });
    dispatch(slice.actions.stopCdnLoading());
    return new Blob([response.data], { type: response.headers['content-type'] });
  } catch (error: any) {
    dispatch(slice.actions.hasErrorCdn(error));
    return error.response.data;
  }
}

export async function getImageUrlFromPath(path: string) {
  dispatch(slice.actions.startCdnLoading());
  try {
    const response = await axios.get(`${process.env.REACT_APP_MAIN_CDN_URL}${CONSTS.CDN_DOWNLOAD_FILE}?path=${path}`, {
      headers: {
        'x-access-token': localStorage.getItem('accessToken') || null
      },
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    dispatch(slice.actions.stopCdnLoading());
    return URL.createObjectURL(blob);

  } catch (error) {
    dispatch(slice.actions.hasErrorCdn(error));
    return 'none';
  }
}


export async function addImagesWithPathToCDNWithReturn(
  files: File[],
  companyId: string,
  path: string
) {
  dispatch(slice.actions.startCdnLoading());
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('companyId', companyId);
    formData.append('path', path);
    const response = await axios.post(
      `${process.env.REACT_APP_MAIN_CDN_URL}${CONSTS.CDN_UPLOAD_FILE}`,
      formData,
      {
        headers: {
          'x-access-token': localStorage.getItem('accessToken') || null
        }
      }
    );
    dispatch(slice.actions.stopCdnLoading());
    return response.data.paths; // return the paths of the uploaded files
  } catch (error: any) {
    dispatch(slice.actions.hasErrorCdn(error));
    return error.response.data;
  }
}